<template>
  <svg
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_4770_31402)">
      <path
        d="M30 60C46.5685 60 60 46.5685 60 30C60 13.4315 46.5685 0 30 0C13.4315 0 0 13.4315 0 30C0 46.5685 13.4315 60 30 60Z"
        fill="url(#paint0_linear_4770_31402)"
      />
      <mask
        id="mask0_4770_31402"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="60"
        height="60"
      >
        <path
          d="M60 30C60 46.5684 46.5678 60 30 60C13.4316 60 0 46.5684 0 30C0 13.4316 13.4316 0 30 0H60V30Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_4770_31402)">
        <path
          opacity="0.2"
          d="M18.6 11.7C20.13 11.43 21.0306 10.53 21.3 9C21.57 10.53 22.4706 11.43 24 11.7C22.4706 11.9706 21.57 12.87 21.3 14.4C21.0306 12.87 20.13 11.9706 18.6 11.7Z"
          fill="#52599D"
        />
      </g>
      <mask
        id="mask1_4770_31402"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="60"
        height="60"
      >
        <path
          d="M60 30C60 46.5684 46.5678 60 30 60C13.4316 60 0 46.5684 0 30C0 13.4316 13.4316 0 30 0H60V30Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask1_4770_31402)">
        <path
          opacity="0.1"
          d="M42.6 44.7C44.13 44.43 45.0306 43.53 45.3 42C45.57 43.53 46.4706 44.43 48 44.7C46.4706 44.9706 45.57 45.87 45.3 47.4C45.0306 45.87 44.13 44.9706 42.6 44.7ZM6.59998 38.7C8.12998 38.43 9.03058 37.53 9.29998 36C9.56998 37.53 10.4706 38.43 12 38.7C10.4706 38.9706 9.56998 39.87 9.29998 41.4C9.03058 39.87 8.12998 38.9706 6.59998 38.7Z"
          fill="#52599D"
        />
      </g>
      <mask
        id="mask2_4770_31402"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="60"
        height="60"
      >
        <path
          d="M60 30C60 46.5684 46.5678 60 30 60C13.4316 60 0 46.5684 0 30C0 13.4316 13.4316 0 30 0H60V30Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask2_4770_31402)">
        <path
          d="M59.9999 0.06C59.9063 0.0708 59.9297 0.0948 59.9399 0C45.9503 1.7874 38.0165 7.3686 33.5189 13.221C33.3598 13.4284 33.2034 13.6378 33.0497 13.8492L33.0449 13.8552C28.2089 20.5176 27.6521 27.4872 27.5999 29.4H26.9999L26.3999 31.2L28.7999 33.6L30.5999 33V32.4C32.0241 32.3723 33.443 32.217 34.8395 31.9362L34.8407 31.9374C35.2781 31.8282 35.3999 31.983 35.3999 34.2V39.6C35.3999 40.6854 35.9657 41.0982 36.5669 40.4964C38.0207 39.0396 38.3687 38.6826 41.6669 35.3796C44.1629 32.8794 44.4725 31.4226 43.4411 28.7442C50.3717 24.8214 57.8591 16.7328 59.9999 0.06Z"
          fill="#52599D"
        />
        <path
          d="M28.7999 33.6L26.3999 31.2L26.9999 29.4H28.1999L30.5999 31.8V33L28.7999 33.6ZM31.1999 16.8C30.1691 16.386 29.9999 16.2 28.7999 16.2C27.5999 16.2 26.2901 17.028 24.6833 18.6378C22.1309 21.1932 21.7733 21.5412 19.5737 23.7426C18.8549 24.4626 19.9577 24.6 21.5999 24.6C24.7397 24.6 27.1781 24.525 28.0745 25.452C29.2583 26.676 31.1999 16.8 31.1999 16.8ZM59.9999 0C59.6165 2.9838 59.0603 5.7474 58.3673 8.2068C57.7379 7.0248 56.8301 5.5884 55.6673 4.4436C54.3767 3.1716 52.7801 2.2644 51.5717 1.6926C55.1873 0.6546 58.0697 0.2472 59.9999 0Z"
          fill="#3B406D"
        />
        <path
          opacity="0.3"
          d="M43.4412 28.7442C44.4726 31.422 44.2284 32.817 41.7288 35.3166C41.2224 35.823 37.032 40.032 36.5664 40.4964C35.9646 41.0976 35.4198 40.6854 35.4 39.6V39.2088C37.2 37.4088 41.2134 33.846 42 32.4C42.4608 31.5534 42.2112 30.2076 42 29.4C40.0128 30.456 35.0904 31.8564 34.8408 31.9374C32.9436 32.325 31.4802 32.3658 30.6 32.4V32.0064C30.6 32.0064 48.585 26.2086 60 0C57.8436 16.8282 50.3718 24.8214 43.4412 28.7442Z"
          fill="white"
        />
        <path
          d="M46.5 16.8C44.3496 16.8 42.6 15.0504 42.6 12.9C42.6 10.7496 44.3496 9 46.5 9C48.6504 9 50.4 10.7496 50.4 12.9C50.4 15.0504 48.6504 16.8 46.5 16.8Z"
          fill="white"
        />
        <path
          d="M46.5 9.59844C47.3752 9.59844 48.2146 9.94611 48.8335 10.565C49.4523 11.1839 49.8 12.0232 49.8 12.8984C49.8 13.7737 49.4523 14.613 48.8335 15.2319C48.2146 15.8508 47.3752 16.1984 46.5 16.1984C45.6248 16.1984 44.7854 15.8508 44.1665 15.2319C43.5477 14.613 43.2 13.7737 43.2 12.8984C43.2 12.0232 43.5477 11.1839 44.1665 10.565C44.7854 9.94611 45.6248 9.59844 46.5 9.59844ZM46.5 8.39844C44.0178 8.39844 42 10.4168 42 12.8984C42 15.38 44.0178 17.3984 46.5 17.3984C48.9822 17.3984 51 15.38 51 12.8984C51 10.4168 48.9822 8.39844 46.5 8.39844Z"
          fill="#3B406D"
        />
        <path
          d="M26.4 31.1992L28.8 33.5992L7.79995 55.1992L4.19995 51.5992L26.4 31.1992Z"
          fill="#D7DCDE"
        />
        <path
          d="M26.3249 31.1992L27.525 32.3992L4.49995 54.8992L2.69995 53.0992L26.3249 31.1992Z"
          fill="#F7F7F7"
        />
      </g>
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_4770_31402"
        x1="30"
        y1="0"
        x2="30"
        y2="60"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#D2D2D2" stop-opacity="0" />
        <stop offset="1" stop-color="#999999" />
      </linearGradient>
      <clipPath id="clip0_4770_31402">
        <rect width="60" height="60" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Rocket',
} as DefineComponent
</script>
